module.exports = ($scope, $uibModalInstance, DataConcierge, workflowStep, comment) ->
  $scope.cancel = ->
    $uibModalInstance.dismiss "cancel"
    return

  $scope.ok = ->
    $scope.saving = true
    DataConcierge.addRequest( $scope.subject, workflowStep.id ).$promise.then (researchRequest) ->
      if $scope.comment
        DataConcierge.addMessage( researchRequest.id, $scope.comment, 0 ).then () ->
          $scope.saving = false
          $uibModalInstance.close researchRequest
        , () ->
          $scope.saving = false
          $uibModalInstance.close false
      else
        $scope.saving = false
        $uibModalInstance.close researchRequest
    , () ->
      $scope.saving = false
      $uibModalInstance.close false

  $scope.subject = undefined
  $scope.comment = comment
  $scope.saving  = false
